import { openDB } from 'idb';
export const DB_NAME = 'colchao-pra-mim';
export const DB_VERSION = 1;
let dbPromise = null;
/**
 * Ponto único de acesso à IndexedDB.
 * Migrações futuras entram no callback `upgrade`.
 */
export function getDB() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade(db, oldVersion) {
                if (oldVersion < 1) {
                    const projects = db.createObjectStore('projects', { keyPath: 'id' });
                    projects.createIndex('by-updatedAt', 'dataAtualizacao');
                    db.createObjectStore('preferences');
                }
            },
            blocked() {
                console.warn('[db] upgrade bloqueado por outra aba aberta');
            },
            blocking() {
                // abandona a conexão para permitir upgrade em outra aba
                dbPromise = null;
            },
        });
    }
    return dbPromise;
}
